<!-- Input Text -->
<input matInput
       class="inputStandard inputForm"
       type="text"
       (mousedown)="$event.stopPropagation()"
       [maxlength]="maxText||4000"
       [minlength]="minText||0"       [ngClass]="{ 'input-error': invalid }"
       [(ngModel)]="valore"
       [disabled]="block ? block : false"
       [hidden]="hidden ? hidden: false"
       [placeholder]="testo ? testo : ''"
       (keyup)="inputChange()">
